export default "__VITE_PUBLIC_ASSET__71fd0838__"